var NLXFramed = false;


$(function () {
  $.support.cors = true;
  $.ajaxSetup({ cache: true });

  InFlight.NLX.Cfg.Customer.getApps(function (data) {
    //$("#header").html(IFT.navbar(data));
    $("#loading").before(IFT.aside(data));

    setTimeout(function () {
      var page = window.location.pathname;
      $('aside .menu .item[href="' + page + '"]').addClass('active');
    }, 800);
    $('aside .ui.accordion').accordion({
      exclusive: true
    });
  });

  $(document).on('click', '#launch', function () {
    $('.ui.sidebar').sidebar({
      scrollLock: true,
      closable: true,
      transition: 'overlay',
      dimPage: false,
      onHidden: function () {
        $('#hamburgerToggle').removeClass("is-active");
      },
      onVisible: function () {
        $('#hamburgerToggle').addClass("is-active");
      }
    })
      .sidebar('toggle');
  });

  //added to autodetect if in a frame or not.
  if (window.self !== window.top) {
    $("hostType").attr("data-if-framed", "true")
    NLXFramed = true;
  }

  if ($("#hostType").attr("data-if-framed") == "true") {
    $(".frameswitch").css("display", "none");
    checkDocumentHeight(sendSizeMsg);
  }

  function checkDocumentHeight(callback) {
    var lastHeight = $("body").outerHeight(), newHeight, timer;
    (function run() {
      newHeight = $("body").outerHeight();
      if (lastHeight != newHeight)
        callback(newHeight);
      lastHeight = newHeight;
      timer = setTimeout(run, 100);
    })();
  }

  InFlight.NLX.Cfg.setDefaults(InFlight.NLX.Cfg.Customer.getNLXDefaults());
});

function clearPopupMessage() {
  $("#popupMessageTitle,#popupMessageContent").text('');

  // set the focus to the first erroneous input, if applicable
  var $errorInputs = $(".PSERROR");
  if ($errorInputs.length) {
    setTimeout(function () { $errorInputs.first().focus() }, 50);
  }
}

function commonCleanUp() {
  //add error className to inputs to outline them in red
  var errorInputs = document.querySelectorAll("[tmpclass=PSERROR]");
  var errorText = $("#error_items").html();
  var isError = (errorText && errorText.length > 0);
  for (var i = 0; i < errorInputs.length; i++) {
    $(errorInputs[i]).addClass("PSERROR");
  }
}

function getDoPortalUrl(scriptText) {
  var url;
  if (scriptText) {
    var pattern = /DoPortalUrl\((?:'([^']+?)'|"([^"]+?)")\)/i;
    var match = scriptText.match(pattern);
    if (match && match.length > 1) { 
      url = match[1];				
    }			
  }

  return url;
}  